import React from 'react';
import { FinanceResponseData } from '@upstart/harmony/lib/legos/financingTypes';
import { Condition } from '@upstart/harmony/lib/legos/constants';
import { FormSectionType, RicMetadata } from '../ricFormTypes';
import { formatCurrency, calculateSumValue } from '../ricFormUtils';
import { renderElement } from './SchemaFormElementRenderer';
import { LineItem } from '../Components';

export const SchemaSection = ({
  formElement,
  responseData,
  fetchResponseWithUpdatedData,
  ricMetadata,
}: {
  formElement: FormSectionType;
  responseData: FinanceResponseData;
  fetchResponseWithUpdatedData: (data: Partial<FinanceResponseData>) => void;
  ricMetadata?: RicMetadata;
}) => {
  const {
    title,
    subtitle,
    value,
    sumValue,
    sectionElements,
    options = {},
  } = formElement;

  const { onlyShowForUsedCar } = options;

  if (onlyShowForUsedCar && responseData.carCondition === Condition.NEW) {
    // Both Used and CPO cars are considered used
    return null;
  }

  const strValue = sumValue
    ? formatCurrency(calculateSumValue(responseData, sumValue))
    : (value ?? '');

  const renderSectionElements = () =>
    sectionElements?.map((sectionElement) =>
      renderElement({
        formElement: sectionElement,
        responseData,
        fetchResponseWithUpdatedData,
        ricMetadata,
      }),
    );

  return (
    <>
      <LineItem title={title} subtitle={subtitle} value={strValue} />
      <div className="form-section">
        {sectionElements && renderSectionElements()}
      </div>
    </>
  );
};

export default SchemaSection;
